import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M5.205 5.205a.7.7 0 0 1 .99 0L10 9.01l3.805-3.805a.7.7 0 1 1 .99.99L10.99 10l3.805 3.805a.7.7 0 1 1-.99.99L10 10.99l-3.805 3.805a.7.7 0 0 1-.99-.99L9.01 10 5.205 6.195a.7.7 0 0 1 0-.99"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
